import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ProductsTotalsRequest } from '../../../models/ss-api/requests/products.totals.request';
import { DialogService } from '../../../services/modal-dialogs/dialog.service';
import { ssApiService } from '../../../services/ss-api.service';
import { GlobalService } from '../../../services/global.service';
import { ProductTotalsItemArray } from '../../../models/ss-api/responses/product.totals.item';
import { ProductItemBasicsArray } from '../../../models/domain/product.item.basics';
import { SearchHomePageProductBreakdownRequest } from '../../../models/ss-api/requests/search.home.page.product.breakdown';
import { SearchService } from '../../../services/search.service';
import { GISOrderHistoryDialog } from '../../../../app/dialogs/gis.order.history/gis.order.history.dialog';
import { GISOrderHistoryItemArray } from '../../../../app/models/domain/gis.order.history.item';

@Component({
    selector: 'products-overview',
    templateUrl: './products.overview.component.html',
    styleUrls: ['./products.overview.component.scss']
})
export class ProductsOverviewComponent implements OnInit {

    IsBusy: boolean = false;

    @Input() archiveDate: Date;

    productTotals: ProductTotalsItemArray = [];
    productTimeStamp: string;

    // NUMBER VARIABLES
    MembersVip3D: number = 0;
    MembersPoolStudio: number = 0;
    MembersVizTerra: number = 0;
    MembersTotal: number = 0;
    MembersYARD: number = 0;
    VendorPartners: number = 0;
    GISOrders: number = 0;
    GISSubscriptions: number = 0;

	MembersOnHold : number = 0;

    MembersSitePlan : number = 0;
 

    constructor(private dialogService: DialogService, private api: ssApiService, private gb: GlobalService, private searchService: SearchService) { }

    ngOnInit() {
        this.InitializeProductTotalsStorage();
    }

    InitializeProductTotalsStorage() {
        let totals = JSON.parse(localStorage.getItem('productTotals'));

        if (totals === undefined || totals === null || moment(totals.timestamp).add(2, 'hours').isBefore(moment())) {
            this.GetProductTotals();
        } else {
            this.productTotals = totals.data;
            this.productTimeStamp = moment(totals.timestamp).format('hh:mm a');
            this.setUpNumbers();
        }
    }

    async GetProductTotals() {
        console.log("getting product totals!!!");
        console.log("archive date", this.archiveDate);

        this.IsBusy = true;

        let request = new ProductsTotalsRequest();
        request.ProductIDs = new Array<number>();
        request.Date = moment(this.archiveDate).toDate();

        let products: ProductItemBasicsArray;

        await this.gb.GetStructureStudiosProductsBasics()
            .then(response => {
                products = response;
            })
            .catch(error => {
                products = new ProductItemBasicsArray();
            })

        if (products != null) {
            products.forEach(item => {
                request.ProductIDs.push(item.ID);
            })
        }

        let subscription = this.api.StatisticsProductsTotals(request).subscribe(response => {
            subscription.unsubscribe();

            this.IsBusy = false;

            if (!response.Result) {
                return;
            }

            let totals = {
                timestamp: new Date(),
                data: response.Data
            }

            var todaysDate = new Date();
            todaysDate.setHours(0,0,0,0);  

            if (moment(this.archiveDate).date() == moment(todaysDate).date()){
                console.log("storing in storage");
                localStorage.setItem('productTotals', JSON.stringify(totals));
                this.productTimeStamp = moment(totals.timestamp).format('hh:mm a');
            }

            this.productTotals = response.Data;    
            this.setUpNumbers();
        },
            error => {
                this.IsBusy = false;
            });

    }

    setUpNumbers() {

		console.log('productTotals : ', this.productTotals);

        this.MembersVip3D = this.productTotals.find(x => x.ProductName == 'VIP3D').Total;
        this.MembersPoolStudio = this.productTotals.find(x => x.ProductName == 'Pool Studio').Total;
        this.MembersVizTerra = this.productTotals.find(x => x.ProductName == 'VizTerra').Total;

        var vp = this.productTotals.find(x => x.ProductName == 'Vendor Package');
        if (vp != null){
            this.VendorPartners = vp.Total;
        }
        else{
            this.VendorPartners = 0;
        }

        var hl = this.productTotals.find( x => x.ProductName == 'Held Licenses' );
        if (hl != null){
            this.MembersOnHold = hl.Total;
        }
        else{
            this.MembersOnHold = 0;
        }

        this.MembersSitePlan = 0;
        this.productTotals.forEach(item => {
            if (item.ProductType == 'structurestudios_membership')
                this.MembersSitePlan += item.Total;
        })        

        this.MembersTotal = this.MembersPoolStudio + this.MembersVip3D + this.MembersVizTerra + this.VendorPartners + this.MembersSitePlan + this.MembersOnHold;

        this.MembersYARD = 0;
        this.productTotals.forEach(item => {
            if (item.ProductType == 'structurestudios_yard')
                this.MembersYARD += item.Total;
        })

        this.GISOrders = 0;

        this.productTotals.forEach(item => {
            if (item.ProductType == 'structurestudios_gis')
                this.GISOrders += item.Total;
        })

        this.GISSubscriptions = 0;

        this.productTotals.forEach(item => {
            if (item.ProductType == 'structurestudios_gisaddon')
                this.GISSubscriptions += item.Total;
        })

    }

    OpenMemberResults(productIDs) {
        this.IsBusy = true;
        let request = new SearchHomePageProductBreakdownRequest();
        request.ProductID = productIDs;

        let disposable = this.api.SearchHomePageProductBreakdown(request).subscribe(result => {
            this.IsBusy = false;
            this.searchService.SetProductOverviewResults(result.Data);
            this.gb.AdvancedSearchClick();

            disposable.unsubscribe();
        });
    }

    OpenYardResults(productIDs) {
        this.IsBusy = true;
        let request = new SearchHomePageProductBreakdownRequest();
        request.ProductID = productIDs;
        request.OnlyYard = true;

        let disposable = this.api.SearchHomePageProductBreakdown(request).subscribe(result => {
            this.IsBusy = false;
            this.searchService.SetProductOverviewResults(result.Data);
            this.gb.AdvancedSearchClick();

            disposable.unsubscribe();
        });
    }

    OpenGISOrderHistoryResults() {
        this.IsBusy = true;

        let disposable = this.api.GetGISOrderHistory().subscribe(result => {
            disposable.unsubscribe();
            this.IsBusy = false;

            this.ShowGISOrderHistoryDialog(result.Data);

        });



    }


    ShowGISOrderHistoryDialog(history: GISOrderHistoryItemArray) {

        let disposableDialog = this.dialogService.addDialog(GISOrderHistoryDialog, {
            GISHistory: history
        }).subscribe(response => {
            disposableDialog.unsubscribe();
            this.IsBusy = false;
        }, error => {
            disposableDialog.unsubscribe();
            this.IsBusy = false;
        });

    }


}
